import React from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import './styles.scoped.css';

const SelectorList = ({
  data = [],
  onSelect,
  value,
  onChange,
  disabled,
  error = false,
  errorMessage = '',
  ...rest
}) => (
  <>
    <Dropdown className="drop" onSelect={onChange} {...rest}>
      <Dropdown.Toggle variant="custom" style={{ width: '100%', overflow: 'hidden' }} disabled={disabled}>
        {value}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {data.map(({ label, value: optionValue }) => (
          <Dropdown.Item key={optionValue} eventKey={optionValue} onSelect={onSelect}>
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
    {error && errorMessage && <span className="error-message">{errorMessage}</span>}
  </>
);

export default SelectorList;
